import type { PropsWithChildren, ReactElement } from 'react'
import * as helmetAsyncModule from 'react-helmet-async'
import type { HelmetProps, HelmetServerState } from 'react-helmet-async'

type HelmetAsyncExports = typeof import('react-helmet-async')
const helmetAsync = (Reflect.get(helmetAsyncModule, 'default') ??
  helmetAsyncModule) as HelmetAsyncExports
const { Helmet: HelmetRoot, HelmetProvider: HelmetProviderRoot } = helmetAsync

interface HelmetProviderProps {
  context?: {
    helmet?: HelmetServerState
  }
}

export const Helmet = HelmetRoot as unknown as (
  props: PropsWithChildren<HelmetProps>,
) => ReactElement

export const HelmetProvider = HelmetProviderRoot as unknown as (
  props: PropsWithChildren<HelmetProviderProps>,
) => ReactElement
